import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule }                  from '@angular/common';
import { CapitalizePipe }                from './capitalize.pipe';
import { FileSizePipe }                  from './file-size.pipe';
import { SortByPipe }                    from './sort.pipe';
import { TitleCasePipe }                 from './title-case.pipe';



@NgModule({
	imports:      [
		CommonModule
	],
	providers:    [],
	exports:      [CapitalizePipe, FileSizePipe, SortByPipe, TitleCasePipe, CommonModule],
	declarations: [CapitalizePipe, FileSizePipe, SortByPipe, TitleCasePipe]
})
export class CsCommonPipesModule {
	static forRoot(): ModuleWithProviders<CsCommonPipesModule> {
		return {ngModule: CsCommonPipesModule, providers: []};
	}
}
